(function(){
  var MAP={
    'Availability':'Dostupnost','Price':'Cijena','Relevance':'Relevantnost',
    'Product type':'Vrsta proizvoda','Vendor':'Proizvođač','Brand':'Brend','Color':'Boja','Colour':'Boja','Size':'Veličina',
    'Featured':'Izdvojeno','Best selling':'Najprodavanije',
    'Alphabetically, A-Z':'Abecedno, A–Ž','Alphabetically, Z-A':'Abecedno, Ž–A',
    'Price, low to high':'Cijena, od najniže','Price, high to low':'Cijena, od najviše',
    'Date, old to new':'Najstarije prvo','Date, new to old':'Najnovije prvo',
    'In stock':'Na stanju','Out of stock':'Nema na stanju'
  };
  function tr(s){var t=s.trim();return MAP[t]?s.replace(t,MAP[t]):null}
  function run(root){
    root=root||document.body;if(!root)return;
    var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null),n,r;
    while(n=w.nextNode()){if(n.parentNode&&/^(SCRIPT|STYLE)$/.test(n.parentNode.nodeName))continue;r=tr(n.nodeValue);if(r!==null)n.nodeValue=r}
    var els=root.querySelectorAll?root.querySelectorAll('[aria-label]'):[];
    for(var i=0;i<els.length;i++){var a=els[i].getAttribute('aria-label');for(var k in MAP){if(a.indexOf(k+' (')===0||a===k){els[i].setAttribute('aria-label',a.replace(k,MAP[k]))}}}
  }
  function start(){
    run();
    var busy=false;
    new MutationObserver(function(ms){if(busy)return;busy=true;for(var i=0;i<ms.length;i++){for(var j=0;j<ms[i].addedNodes.length;j++){var x=ms[i].addedNodes[j];if(x.nodeType===1)run(x);else if(x.nodeType===3){var r=tr(x.nodeValue);if(r!==null)x.nodeValue=r}}}busy=false}).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
